import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { Switch, Route, Redirect } from 'react-router-dom'

import TextField from 'components/TextField'
import SearchField from 'components/SearchField'
import Button from 'components/buttons/Button'
import PageControl from 'components/PageControl'

import Modal from 'components/Modal'
import FortnightPickerField from 'components/FortnightPickerField'

import SectionWithHeader from 'layout/SectionWithHeader'

import BreakReportList from 'lists/BreakReportList'

import ReportsPay from './Pay'
import ReportsBreak from './Break'

import { LoadingBox } from 'components/LoadingSpinner'
import ReportsAPI from 'api/ReportsAPI'

import ProtectedRoute from 'utils/ProtectedRoute'
import { getMe } from 'utils/auth'
import { Roles } from 'api/UsersAPI'

import {dateToFortnight} from 'utils/time'

import styles from './index.css'

@withRouter
export default class Reports extends React.Component {
  
  static propTypes = {
  }

  constructor(props) {
    super(props)

    const { search, fortnight } = JSON.parse(window.sessionStorage["pay_reports"] || '{}')
    this.state = {
      loading: true,
      //fortnight: fortnight ? new Date(fortnight) : dateToFortnight(new Date()).from
    }
  }

  async componentDidMount() {
    const {response} = await ReportsAPI.getLastPayPeriod()
    if (response) {
      this.setState({
        fortnight: response.start_date ? new Date(response.start_date) : dateToFortnight(new Date()).from
      })
    }
    this.setState({
      loading: false,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (!prevState.fortnight && this.state.fortnight) ||
      (prevState.fortnight && prevState.fortnight.getTime() !== this.state.fortnight.getTime())
    ) {
      window.sessionStorage["pay_reports"] = JSON.stringify({ fortnight: this.state.fortnight })
    }
  }

  render() {
    if (this.state.loading) return <LoadingBox />
    const me = getMe()
    return (
      <div className={styles.Page}>

        <SectionWithHeader
          title={"Reports"}
          headerChildren={
            <div style={{display: 'flex', alignItems: 'center' }}>
              {
                window.location.href.endsWith('pay') &&
                  <div style={{paddingRight: '2rem'}}>
                    <FortnightPickerField 
                      value={this.state.fortnight}
                      onChange={fortnight => this.setState({ fortnight })}
                      />
                  </div>
              }
              <Button
                style={{
                  borderTopRightRadius: '0',
                  borderBottomRightRadius: '0',
                }}
                color={window.location.href.endsWith('break') ? 'darkbluewhite' : 'greyblue'}
                fullWidth={false}
                onClick={() => this.props.history.push('/reports/break')}>
                Break reports
              </Button>
              {
                me && me.role == Roles.Admin &&
                  <Button 
                    style={{
                      borderTopLeftRadius: '0',
                      borderBottomLeftRadius: '0',
                    }}
                    color={window.location.href.endsWith('pay') ? 'darkbluewhite' : 'greyblue'}
                    fullWidth={false}
                    onClick={() => this.props.history.push('/reports/pay')}>
                    Pay reports
                  </Button>
              }
            </div>
          }>

          <Switch>
            <Route path='/reports/break' component={ReportsBreak} />

            <ProtectedRoute allowedRoles={[Roles.Admin]} path='/reports/pay' component={props => {
              return <ReportsPay fortnight={this.state.fortnight}/>
            }} />

            <Redirect to='/reports/break' />
          </Switch>
        </SectionWithHeader>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Reports/index.jsx